import styled from '@emotion/styled';
import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import { StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import { ProgramEnum } from 'src/modules/programs/models/programs';
import * as S from 'src/modules/programs/stepComponents/styles';
import { SimpleSurveyStep } from 'src/modules/programs/surveys/stepComponents/SimpleSurveyStep';

import { color, font } from 'src/shared/styles/variables';
import { CBTProgramWeekFiveSurvey } from '../models/weekFive';

const ColoredSentence = styled('p')(
    {
        marginBottom: '1.5rem',
        color: color.blueLagoon,
    },
    font.medium(font.size.medium),
);

interface Props extends StepButtonsProps, WithTranslation {
    programId: ProgramEnum;
}

export const LookingAtAlternativesStep = withTranslation('cbt')((props: Props) => (
    <SimpleSurveyStep
        {...props}
        programId={props.programId}
        surveyId={CBTProgramWeekFiveSurvey.LookingAtAlternatives}
        heading={
            <>
                <S.StepHeading>{props.t('week-5.looking-at-alternatives.title')}</S.StepHeading>
                <S.StepDescription small>
                    {props.t('week-5.looking-at-alternatives.description.1')}
                </S.StepDescription>
                <ColoredSentence>
                    {props.t('week-5.looking-at-alternatives.description.2')}
                </ColoredSentence>
            </>
        }
    />
));
